import React, { useEffect } from 'react'
import AddMashup from '../components/AddMashup/AddMashup'

function Exclusive(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
      <h1>{props.title}</h1>
    
      <div id="exclusive">
        <h2>Exclusive Mashups</h2>
        
        <AddMashup title="(Version 2) AOA x Gfriend x Gugudan - Bing Bing x Me Gustas Tu x The Boots Mashup" type="exclusive"/>
        <AddMashup title="(Version 2) EXO-CBX x Snuper - Blooming Day x Tulips Mashup" type="exclusive"/>
        <AddMashup title="(Version 2) Gugudan x Momoland x Red Velvet - A Girl Like Me x Freeze x Red Flavor Mashup" type="exclusive"/>
        <AddMashup title="BoA x NCT DOJAEJUNG x Red Velvet - IRENE & SEULGI x SEVENTEEN - Camo x Perfume x Naughty x Hot Mashup" type="exclusive"/>
        <AddMashup title="SEVENTEEN x The Boyz - Good to Me x Sweet Mashup" type="exclusive"/>
        <div class="bottom-space"><br /></div>
      </div>
    </main>
  )
}

export default Exclusive